import { makeStyles, Theme } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

interface IStylesProps {
  backgroundColor: string;
  size: number;
  marginRight: number;
}

export default makeStyles<Theme, IStylesProps>((theme: MuiTheme) => ({
  indicator: {
    height: ({ size }) => `${size}px`,
    width: ({ size }) => `${size}px`,
    marginRight: ({ marginRight }) => `${marginRight}px`,
    backgroundColor: ({ backgroundColor }) =>
      backgroundColor ? `#${backgroundColor}` : theme.palette.text.primary
  }
}));
